import { render, staticRenderFns } from "./Physics.vue?vue&type=template&id=2aaf0f3d&"
import script from "./Physics.vue?vue&type=script&lang=js&"
export * from "./Physics.vue?vue&type=script&lang=js&"
import style0 from "./Physics.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports